import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Box, IconButton, Typography } from '@mui/material';
import { type DragEvent, FC } from 'react';

import { nativeStyles, styles } from './draggable-image-card.styles';

export interface IDraggableImageCardProps {
  src: string;
  index: number;
  totalItems: number;
  width?: number | string;
  height?: number | string;
  dragOverIndex: number | null;
  onDragStart: (index: number) => void;
  onDragOver: (index: number) => void;
  onDragLeave: () => void;
  onDrop: (index: number) => void;
  onSwap: (index1: number, index2: number) => void;
  onDelete: (index: number) => void;
}

export const DraggableImageCard: FC<IDraggableImageCardProps> = ({
  dragOverIndex,
  height = 160,
  index,
  onDelete,
  onDragLeave,
  onDragOver,
  onDragStart,
  onDrop,
  onSwap,
  src,
  totalItems,
  width = 160,
}) => {
  const handleDragStartLocal = (e: DragEvent<HTMLDivElement>) => {
    onDragStart(index);
    if (e.dataTransfer) {
      const imgNode = e.currentTarget.querySelector('img');
      if (imgNode) e.dataTransfer.setDragImage(imgNode, 80, 80);
    }
  };

  const handleDragOverLocal = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    if (dragOverIndex !== index) onDragOver(index);
  };

  const handleDropLocal = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    onDrop(index);
  };

  return (
    <Box
      draggable
      onDragLeave={onDragLeave}
      onDragOver={handleDragOverLocal}
      onDragStart={handleDragStartLocal}
      onDrop={handleDropLocal}
      sx={[
        { ...(styles.imageCard as object), width, height },
        dragOverIndex === index && (styles.dragOver as object),
      ]}
    >
      <img alt={`card-img-${index}`} src={src} style={nativeStyles.imageElement} />

      <Typography sx={styles.orderBadge}>{index + 1}</Typography>

      <Box sx={styles.controlsBox}>
        <IconButton
          disabled={index === 0}
          disableRipple
          onClick={() => onSwap(index, index - 1)}
          size="small"
        >
          <ArrowBackIosNewIcon fontSize="small" />
        </IconButton>

        <IconButton color="error" disableRipple onClick={() => onDelete(index)} size="small">
          <DeleteOutlineIcon fontSize="small" />
        </IconButton>

        <IconButton
          disabled={index === totalItems - 1}
          disableRipple
          onClick={() => onSwap(index, index + 1)}
          size="small"
        >
          <ArrowForwardIosIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
};
